
import React, { Component } from "react";
import BsyGroupList from "../BsyGroupList";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlertMenu from "../BsyAlertMenu";
import ManagerPane from "./ManagerPane";
import { BsyUtils } from "../../utils/Utils";


import './index.css';

export default class BsySysManager extends Component {

    constructor(props) {
        super(props)
        this.state = {
            apps: [],
            dept_range: [],
            role_range: [],
            outsider_range: [],
            members: [],
            name: '',
            op: {},
            owner: {},
            group_id: -1,
            groups: [{
                "_id": "default",
                "name": React.language('default.group'),
                "sort": "0",
                "type": "1"  //1是默认分组
            }], //外联系人分组分组列表

        }

    }


    componentDidMount() {
        this.getGroupList();
    }

    getGroupList = () => {
        React.axios('/corp/manage/group_list', {
            corpId: window.FX.STATIC.corpId,
        }).then(res => {
            res.data.manageGroups[0].type = 1;
            res.data.manageGroups[0].icon = 'icon-outsider-member';
            this.setState({
                groups: [...res.data.manageGroups],
            }, () => {
                this.state.groups.map((cc, index) => {
                    this.group_id = cc.group_id
                    return cc;
                })
                this.setState({ group_id: this.group_id }, () => {
                    this.RefreshList();
                })
            })
        }).catch(res => {

        })
    }

    groupNodeClick = (node) => {

        this.setState({
            group_id: node.group_id
        }, () => {
            this.RefreshList()
        })


        // this.setState({
        //     group_id: node ? node._id : null,
        //     selectGroupName: node ? node.name : React.language('sysManager.custom.all'),
        //     miniAppSet: !node ? false : node.mini,
        //     openurl: !node ? '' : node.openurl,
        //     openurl_switch: !node ? false : node.openurl_switch,
        //     skip: 0,
        //     filter: ""
        // }, () => {
        //     this.RefreshList();
        // })


    }

    eventCustMent = (type, node, event) => {

        const { groups } = this.state;
        const _this = this;
        switch (type) {
            case "del": {
                window.FX.Msg.alert({
                    type: "warning",
                    title: React.language("delete.confirm", {
                        name: node.name
                    }),
                    text4Ok: React.language("delete"),
                    msg: React.language("manager.delete.warning1"),
                    onOk: function () {
                        React.axios("/corp/manage/group/remove", {
                            corpId: window.FX.STATIC.corpId,
                            group_id: node.group_id,
                        }).then(res => {

                            BsyUtils.showAjaxTip(res.data, () => {
                                const newGroups = groups.filter((item, index) => {
                                    return item._id !== node._id;
                                })
                                _this.setState({ groups: newGroups })
                            })

                        }).catch(res => {
                            console.log(res)
                        })
                    }
                });
                break;
            }
            case 'rename': {
                window.FX.Msg.nAlter({
                    renderEl: window.$(event.target),
                    title: React.language("edit.Management.Group.tip"),
                    name: node.title,
                    placeholder: React.language("name.placeholder"),
                    onOk: function (c2) {
                        var value = "";
                        if (!!c2.checkValidate()) {
                            value = c2.getValue();
                        }
                        if (!value) {
                            tipAlert({
                                type: "warning",
                                msg: React.language('manager.name.notEmpty')
                            })
                            return;
                        }

                        if (value.length > 32) {
                            tipAlert({
                                type: "warning",
                                msg: React.language("manager.name.tooLong", { length: 32 })
                            })
                            return;
                        }
                        if (node.name === value) {
                            return;
                        }

                        React.axios("/corp/manage/group/update",
                            {
                                name: value,
                                group_id: node.group_id,
                                corpId: window.FX.STATIC.corpId,
                            })
                            .then(res => {

                                const newGroups = groups.map((item, index) => {
                                    if (item.group_id === node.group_id) {
                                        item.name = value;
                                    }
                                    return item;
                                })
                                _this.setState({ groups: newGroups, group_id: node.group_id })

                            }).catch(res => {
                            })
                    }
                })
                break;
            }
            default: {

            }
        }
    }

    sysManagerGroupMoreOperate = (e, node) => {
        // this.RefreshList()
        // this.setState({ selectGroup: node._id })
        let menu = [{
            text: React.language('rename'),
            colorType: "",
            click: () => {
                this.eventCustMent('rename', node, e);
            }
        }, {
            text: React.language('delete'),
            colorType: "red",
            click: () => {
                this.eventCustMent('del', node, e);
            }
        }]
        if (node.type === 1) {
            this.eventCustMent('rename', node, e);
        } else {
            BsyAlertMenu({
                item: menu,
                // renderEl: e.currentTarget,
                width: 100,
                target: e.currentTarget,

            })

        }

    }

    memberUpdate = (data) => {

        React.axios("/corp/sysManager/member/update", data).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {
                this.RefreshList();
                tipAlert({
                    type: "success",
                    msg: React.language("update.success")
                })
            })

        }).catch(res => {

        })
    }

    groupNodeAdd = () => {
        const _this = this;
        var f = new window.FX.ConfirmDialog({
            title: React.language("new.Management.Group"),
            width: 340,
            height: 170,
            text4Ok: React.language("add"),
            contentWidget: {
                rowSize: [30],
                colSize: [300],
                padding: 20,
                items: [[{
                    type: "text",
                    widgetName: "groupName",
                    waterMark: React.language('manager.placeholder'),
                    allowBlank: !1
                }]]
            },
            onOk: function () {
                var g = this.getWidgetByName("groupName");
                var value = g.getValue();
                if (!value) {
                    tipAlert({
                        type: "warning",
                        msg: React.language('manager.name.notEmpty')
                    })
                    return;
                }

                if (value.length > 32) {
                    tipAlert({
                        type: "warning",
                        msg: React.language("manager.name.tooLong", { length: 32 })
                    })
                    return;
                }
                _this.group_id++;
                React.axios("/corp/manage/group/update", {
                    name: value,
                    corpId: window.FX.STATIC.corpId,
                    group_id: _this.group_id
                }).then(res => {
                    _this.getGroupList();
                    f.close()
                }).catch(res => {
                    f.close()
                })
            }
        });
        f.show()
    }



    RefreshList = () => {
        const { group_id } = this.state

        let url = '/corp/manage/group/get_config';

        React.axios(url, {
            corpId: window.FX.STATIC.corpId,
            group_id: group_id
        }).then(res => {

            const newState = {
                ...this.state,
                ...res.data,
            }
            this.setState(newState)

        }).catch(res => {

        })
    }



    render() {
        const { apps, dept_range, role_range, outsider_range, members, op, name, groups, group_id, owner } = this.state;
        const { is_tmp_owner } = this.props;
        let defList = [groups[0]];
        let goupList = [];
        groups.map((res, key)=>{
            if(key === 0){
                return
            }
            res.icon = "icon-outsdier-custom-group"
            goupList.push(res)
        })
        return (


            <div className={"sysManagerCont " + window.mode}>
                <div className="sysManagerMenu">
                    <div className="group-title">
                        <span>{React.language('manage.group.system.name')}</span>
                    </div>
                    <div className="defGroupList">
                        {
                            defList.map(res => {
                                return <div className={"def-group-item " + (group_id === res.group_id ? 'select':'')} onClick={() => this.groupNodeClick(res)}>
                                    <i className="title-icon icon-outsider-member"></i>
                                    <span>{res.name}</span>
                                </div>
                            })
                        }
                    </div>
                    <div className="group-title">
                        <span>{React.language('manager.normal')}</span>
                        <i className="icon-add" onClick={this.groupNodeAdd}></i>
                    </div>
                    <BsyGroupList
                        groups={goupList}
                        selectGroup={group_id}
                        hasCustom={false}
                        nodeClick={(node) => this.groupNodeClick(node)}
                        nodeAdd={() => this.groupNodeAdd()}
                        keyid={'group_id'}
                        nodeMoreOperate={(e, node) => this.sysManagerGroupMoreOperate(e, node)}
                        hasDeletedList={false}
                        // splitMenuIcon={'icon-bsy-iconputongguanlizu'}
                        splitMenuName={React.language('manager.normal')}
                    />

                </div>
                <div className="sysManagerContent">
                    <div className="sysManagerTitle">
                        <div className="leftsysManagerCont">
                            <div className="title">
                                {name}
                            </div>
                        </div>

                    </div>
                    <ManagerPane
                        is_tmp_owner={is_tmp_owner}
                        apps={apps}
                        dept_range={dept_range}
                        role_range={role_range}
                        outsider_range={outsider_range}
                        members={members}
                        name={name}
                        op={op}
                        owner={owner}
                        group_id={group_id}
                    />

                </div>
            </div>

        );
    }
}